// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"915d8aeb","110":"cfb131f7","258":"7663ef3e","547":"61e8907c","638":"585c03aa","729":"3c8fb38b","878":"89e83301","916":"52753a5d","932":"7c942a8a"}[chunkId] + ".chunk.css";
};